import { client, threeDSecure } from "braintree-web";
import { useEffect, useState } from "react";
import { usePayment } from "./usePayment";
import { useNotifications } from "./useNotifications";
export var useBraintreeClient = function () {
    var clientToken = usePayment().clientToken;
    var _a = useState(), clientInstance = _a[0], setClientInstance = _a[1];
    var _b = useState(), threeDSecureInstance = _b[0], setThreeDSecureInstance = _b[1];
    var notify = useNotifications().notify;
    useEffect(function () {
        client
            .create({
            authorization: clientToken,
        })
            .then(function (braintreeClientInstance) {
            setClientInstance(braintreeClientInstance);
            return threeDSecure.create({
                version: 2,
                client: braintreeClientInstance,
            });
        })
            .then(function (threeDSecureInstance) {
            threeDSecureInstance.on("lookup-complete", function (data, next) {
                if (next) {
                    next();
                }
            });
            setThreeDSecureInstance(threeDSecureInstance);
        })
            .catch(function (err) {
            notify("Error", err.message);
        });
    }, [clientToken]);
    return {
        client: clientInstance,
        threeDS: threeDSecureInstance,
    };
};
